import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Summon extends Bloc {

	constructor (src, ctx) {

		super("summon", src, ctx, true);
		this.f = (src, ins) => {
			src.master.spawnEnemy(ins[0]);
			return [];
		};
		this.types = [Types.string];
	}
}
